import { JBaseApi } from '../base';
import { OF } from '../../util/network';
import { ApiWrapper } from '../../types/utils';
import { StoreFinalize, StoreItem } from '../../types/adminStore';

export class AdminStoreApi extends JBaseApi {
    public getItem(uri: string): Promise<ApiWrapper<StoreItem>> {
        return this.network.post({
            o: 'adminStore',
            f: 'getItem',
            uri,
        } as OF);
    }
    public checkoutBilling(uri: string): Promise<ApiWrapper<boolean>> {
        return this.network.postCSRF({
            o: 'adminStore',
            f: 'checkoutBilling',
            uri,
        } as OF);
    }
    public checkoutFinalize(uri: string): Promise<ApiWrapper<StoreFinalize>> {
        return this.network.postCSRF({
            o: 'adminStore',
            f: 'checkoutFinalize',
            uri,
        } as OF);
    }
}
